export const ArrowRedoIcon2 = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9102 7.36739C15.6442 7.09987 15.2126 7.09987 14.9466 7.36739C14.6811 7.6344 14.6811 8.06691 14.9466 8.33391L15.8432 9.23571H9.94271C7.67217 9.23571 5.83317 11.0867 5.83317 13.3679C5.83317 15.6491 7.67217 17.5001 9.9427 17.5001H14.7427C15.1197 17.5001 15.4237 17.193 15.4237 16.8162C15.4237 16.4394 15.1197 16.1323 14.7427 16.1323H9.9427C8.42613 16.1323 7.19508 14.8955 7.19508 13.3679C7.19508 11.8403 8.42613 10.6035 9.94271 10.6035H15.8432L14.9466 11.5053C14.6811 11.7723 14.6811 12.2048 14.9466 12.4718C15.2126 12.7394 15.6442 12.7394 15.9102 12.4718L17.9674 10.4029C18.2329 10.1359 18.2329 9.70336 17.9674 9.43636L15.9102 7.36739Z"
      />
    </svg>
  );
};
